import React from 'react';
import { Link } from "react-router-dom";
import '../Styles/RegistrationCampSelection.scss';
import combinationPhoto from "../Images/CombinationWeekImg.jpg"
import dayCampPhoto from "../Images/DayCampImage.jpg"
import retreatPhoto from "../Images/RetreatPhoto.jpg"
import familyCampPhoto from "../Images/FamilyCampImage.jpg"

function RegistrationCampSelection() {
   return(
      <div className="RegistrationCampSelectionContainer">
         <div className="RegistrationCampSelectionContent">
            <div className="RegistrationCampSelectionHeading">
               Choose Your Camp
            </div>
            <div className="RegistrationCampSelectionDescription">
               Please select your preferred camp to begin the registration process.
            </div>
            <div className="RegistrationCampSelectionOptions">
               <div className="RegistrationCampsSelectionDayCampOption">
                  <div className="RegistrationCampsSelectionDayCampOptionImage">
                     <img
                        src={dayCampPhoto}
                        alt='Image for Combination Week'
                        style={{ width: "100%"}} 
                     />
                  </div>
                  <div className="RegistrationCampsSelectionDayCampOptionHeading">
                     Day Camps         
                  </div>
                  <div className="RegistrationCampsSelectionDayCampOptionDescription">
                     Day camps for junior-age children with Ranch favorites like horse rides and the rodeo!
                  </div>
                  <div className="RegistrationCampsSelectionDayCampOptionContent">
                     <Link to={'/daycampregistration'}>
                        <button>
                         Register
                        </button>
                   </Link>
                  </div>
               </div>
               <div className="RegistrationCampsSelectionCombinationCampOption">
                  <div className="RegistrationCampsSelectionCombinationCampOptionImage">
                     <img
                        src={combinationPhoto}
                        alt='Image for Combination Week'
                        style={{ width: "100%"}} 
                     />
                  </div>
                  <div className="RegistrationCampsSelectionCombinationCampOptionHeading">
                     Overnight Camps         
                  </div>
                  <div className="RegistrationCampsSelectionCombinationCampOptionDescription">
                    Camps for juniors, teens, and deaf. Join your church or come by yourself!
                  </div>
                  <div className="RegistrationCampsSelectionCombinationCampOptionContent">
                     <Link to={'/individualregistration'}>
                        <button>
                           Register
                        </button>
                     </Link>
                  </div>
                  
               </div>
               <div className="RegistrationCampsSelectionRetreatOption">
                   <div className="RegistrationCampsSelectionRetreatOptionImage">
                     <img
                        src={retreatPhoto}
                        alt='Image for Combination Week'
                        style={{ width: "100%"}} 
                     />
                  </div>
                    <div className="RegistrationCampsSelectionRetreatOptionHeading">
                     Retreats
                  </div>
                  <div className="RegistrationCampsSelectionRetreatOptionDescription">
                    Weekend retreats including getaways for couples, men, and ladies.
                  </div>
                 <div className="RegistrationCampsSelectionRetreatOptionContent">
                     <Link to={'/retreatregistration'}>
                        <button>
                           Register
                        </button>
                     </Link>
                 </div>
               </div>
               <div className="RegistrationCampsSelectionFamilyCampOption">
                   <div className="RegistrationCampsSelectionFamilyCampOptionImage">
                     <img
                        src={familyCampPhoto}
                        alt='Image for Combination Week'
                        style={{ width: "100%"}} 
                     />
                  </div>
                   <div className="RegistrationCampsSelectionFamilyCampOptionHeading">
                     Family Camps 
                  </div>
                  <div className="RegistrationCampsSelectionFamilyCampOptionDescription">
                    Camps for families to get closer to each other and to the Lord!
                  </div>
                  <div className="RegistrationCampsSelectionFamilyCampOptionContent">
                     <button>
                        Coming Soon
                     </button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default RegistrationCampSelection